import { type ChangeEvent, Component } from 'react';
import { Checkbox, FormGroup, HTMLSelect } from '@blueprintjs/core';
import { formatNumber } from 'accounting';

import { type Settings } from '../../../settings';

const Buckets = (props: {
  isDisabled: boolean;
  formsEnabled: boolean;
  options: Record<string, { totalMonthly: number; totalAnnually: number }>;
  value: number;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
}) => {
  const { isDisabled, options, onChange, value } = props;
  return props.formsEnabled ? (
    <FormGroup className="options">
      <HTMLSelect
        disabled={isDisabled}
        fill
        options={Object.keys(options).map((key) => formatNumber(Number(key)))}
        value={formatNumber(value)}
        onChange={onChange}
      />
    </FormGroup>
  ) : (
    <>{formatNumber(value)}</>
  );
};

type DataExportProps = Readonly<{
  isChecked: boolean;
  isDisabled: boolean;
  formsEnabled: boolean;
  options: Record<string, { totalMonthly: number; totalAnnually: number }>;
  value: number;
  onChange: (event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => void;
  settings: Settings;
}>;

export class DataExport extends Component<DataExportProps> {
  private handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(event);
  };

  private handleSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    this.props.onChange(event);
  };

  public render() {
    const { isChecked, isDisabled, formsEnabled, options, value } = this.props;

    return this.props.settings.dataExportPercentagePricing ? (
      <FormGroup className="options">
        <Checkbox checked={isChecked} disabled={isDisabled} onChange={this.handleCheckboxChange} />
      </FormGroup>
    ) : (
      <Buckets
        isDisabled={isDisabled}
        formsEnabled={formsEnabled}
        options={options}
        onChange={this.handleSelectChange}
        value={value}
      />
    );
  }
}
